// Movie API routes
const MOVIE = '/movie'
const MOVIE_POPULAR = `${MOVIE}/popular`
const MOVIE_TRENDING = `${MOVIE}/trending`

export { MOVIE, MOVIE_POPULAR, MOVIE_TRENDING }
